import React, { Component } from 'react'
import PropTypes from 'prop-types'

import CSSModules from 'react-css-modules'
import { IconMenu, MenuItem } from 'react-toolbox/lib/menu'

import theme from './ApprovalActions.scss'

class ApprovalActions extends React.Component {
  constructor(props){
    super(props)

    this.state = {
      show: false
    }
  }

  onShow(){
    this.setState({
      ...this.state,
      show: true
    })
  }

  onHide(){
    this.setState({
      ...this.state,
      show: false
    })
  }

  classes(){
    let classes = theme.approvalIconMenu
    if (this.state.show) classes = `${classes} ${theme.show}`
    return classes
  }

  render() {
    let {
      rejectApproval,
      acceptApproval
    } = this.props

    return (
      <IconMenu
        selectable
        icon='more_vert'
        position='bottomRight'
        menuRipple
        onShow={() => this.onShow()}
        onHide={() => this.onHide()}
        class={this.classes()}
        theme={theme}>
        <MenuItem
          onClick={ acceptApproval }
          className={theme.approveItem}
          caption='Approve'
          icon='check'
          theme={theme}/>
        <MenuItem
          onClick={ rejectApproval }
          className={theme.rejectItem}
          caption='Reject'
          icon='close'
          theme={theme}/>
      </IconMenu>
    )
  }
}

ApprovalActions.propTypes = {
  rejectApproval: PropTypes.func.isRequired,
  acceptApproval: PropTypes.func.isRequired
}

export default CSSModules(ApprovalActions, theme)
